module.exports = __webpack_public_path__ + "img/1536946627.1f1530ef.jpg";